import perfectScrollbar, { type PerfectScrollbarOptions } from "vue3-perfect-scrollbar"
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css"

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(perfectScrollbar)
})

declare module "vue" {
	export interface GlobalComponents {
		PerfectScrollbar?: Component<PerfectScrollbarOptions>
	}
}
